import { Routes } from '@angular/router';
import { FirstRunWorkspaceComponent } from './first-run-workspace.component';
import { PermissionGuard } from '../security/permission.guard';
import { app_permissions } from '../security/app-permissions';
import { TenantMasterDataImportComponent } from './master-data-import/tenant-master-data-import.component';

export const onboardingRoutes: Routes = [
    {
        path: 'onboarding/start',
        component: FirstRunWorkspaceComponent,
        canActivate: [PermissionGuard],
        data: { permission: app_permissions.onboarding.start }
    },
    {
        path: 'setup/master-data-import',
        component: TenantMasterDataImportComponent,
        canActivate: [PermissionGuard],
        data: { permission: app_permissions.onboarding.manage }
    }
];
